<template lang="pug">
b-form-group(label="Tipo de Cliente" label-for="tipo-cliente")
  b-form-radio-group(
    v-model="selectedType"
    id="tipo-cliente"
    name="tipo-cliente"
    @change="handleTypeChange"
    button-variant="outline-primary"
    buttons
  )
    b-form-radio(value="persona") Persona
    b-form-radio(value="empresa") Empresa
</template>

<script>
export default {
  name: 'ClientTypeSelector',
  props: {
    value: {
      type: String,
      default: 'persona',
      validator: (value) => ['persona', 'empresa'].includes(value),
    },
  },
  data() {
    return {
      selectedType: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.selectedType = newVal
    },
  },
  methods: {
    handleTypeChange(newType) {
      this.$emit('input', newType)
      this.$emit('type-changed', newType)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .btn-group-toggle {
  width: 100%;
  display: flex;

  .btn {
    flex: 1;
    border-color: #ced4da;
    color: #495057;
    background-color: #fff;
    
    &:hover {
      background-color: #f8f9fa;
      border-color: #ced4da;
    }

    &.active {
      background-color: #fece2f !important;
      border-color: #fece2f !important;
      color: #000 !important;
    }
  }
}
</style>
